import { render, staticRenderFns } from "./RoleSidebar.vue?vue&type=template&id=f15e350c&scoped=true&"
import script from "./RoleSidebar.vue?vue&type=script&lang=js&"
export * from "./RoleSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RoleSidebar.vue?vue&type=style&index=0&id=f15e350c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15e350c",
  null
  
)

export default component.exports